module.exports = __webpack_public_path__ + "img/sg.f835ba1b.svg";